import { render, staticRenderFns } from "./TopButtonBar.vue?vue&type=template&id=b4b983b8&"
import script from "./TopButtonBar.vue?vue&type=script&lang=js&"
export * from "./TopButtonBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports